<template>
  <main class="main__post post">
    <div class="post__container container">
      <div class="post__top">
        <i class="post__back" v-text="ui.nav_back_label" @click="$router.go(-1)" />
        <!-- <div v-if="page.date" class="post__date" v-text="page.date.slice(0, -9)" /> -->
        <div class="post__date" v-text="page.date.slice(0, -9)" />
        <h1 v-text="page.title" />
      </div>
      <article class="post__article" v-html="page.content_inner" />
      <div v-if="page.files.length" class="post__files">
        <div class="post__file file" v-for="(file, f) in page.files"
          :key="f">
          <file-icon class="file__icon"/>
          <div class="file__title" v-text="file.single_file.replace('/', '')" />
          <a :href="mediaPath(file.single_file)" download target="_blank" class="file__link"></a>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import page from '@/mixins/page'
import FileIcon from '@/elements/FileIcon'

export default {
  mixins: [page],
  components: {
    FileIcon
  },
  computed: {},
  name: 'PostTemplate'
}
</script>



// WEBPACK FOOTER //
// src/templates/PostTemplate.vue